import { IForm } from "form/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { FieldCaps } from "../../fields/FieldCaps"

interface IConfigurationCapsFormProps {
  form: IForm
  readOnly?: boolean
}

export const ConfigurationCapsForm = React.memo(({ form, readOnly }: IConfigurationCapsFormProps): JSX.Element => {
  const {
    context,
    configuration: { caps }
  } = form
  const capsErrors = context.configuration.errors.caps
  return (
    <FlexBox
      vertical
      ai="start"
      jc="start"
      gap
      fullWidth
      sx={{
        "height": "100%",
        "minHeight": "100%",
        "maxHeight": "100%",
        "p": "1rem",
        "& > *": {
          width: "15rem"
        }
      }}>
      <FieldCaps caps={caps} capErrors={capsErrors} disabled={readOnly} />
    </FlexBox>
  )
})
